import type { FC } from 'react';

import type { SxProps, TextFieldProps, Theme } from '@mui/material';

import { StyledTextField } from './styles';

import Skeleton from '../skeleton';

export type TSelectNative = {
  preload?: boolean;
  width?: number | string;
  height?: number | string;
} & TextFieldProps;

const SelectNative: FC<TSelectNative> = ({
  variant = 'outlined',
  margin = 'normal',
  size = 'small',
  SelectProps = {},
  preload,
  width,
  height,
  className,
  ...rest
}) => {
  const mergedSx: SxProps<Theme> | undefined =
    height !== undefined
      ? {
          ...(rest.sx && !Array.isArray(rest.sx) ? rest.sx : {}),
          '& .MuiInputBase-root': { height },
        }
      : rest.sx;

  if (preload) {
    return <Skeleton width={width} height={height ?? 48} variant="rectangular" className={`${className || ''}`} />;
  }

  return (
    <StyledTextField
      select
      SelectProps={{
        native: true,
        ...SelectProps,
      }}
      variant={variant}
      margin={margin}
      size={size}
      className={`${className || ''}`}
      sx={mergedSx}
      {...rest}
    />
  );
};

export default SelectNative;
